<template>
	<Card>
		<div style="width: 750px">
			<Input v-model="name" style="width:150px;margin-left: 10px;" placeholder="请输入城市/计划名称"></Input>
			<Select v-model="cid_type" multiple style="width: 150px;margin-left: 10px;">
				<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">
					{{ item.type}}
				</Option>
			</Select>
			<Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</Button>
			<Button @click="initSearch" style="margin-left: 10px;">重置</Button>
			<Button type="primary" @click="addSingleDefaultCityDemand" style="margin-left: 10px;">添加投放计划</Button>
			<Button type="primary" @click="addIndexStandard" style="margin-left: 10px;">指标标准管理</Button>
		</div>
		<h3>当日投放情况</h3>
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="allColumns" :data="allDatas" ref="alltable" >
				<template slot-scope="{ row,index }" slot="plans_with_bids_combination">
					<div v-for="(item,index) in row.plans_with_bids_combination" style="margin-bottom: 5px;"  :key="index">
						<span style="margin-bottom: 10px;">{{item}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="plans_with_bids_single">
					<div v-for="(item,index) in row.plans_with_bids_single" style="margin-bottom: 5px;" :key="index">
						<span style="margin-bottom: 10px;">{{item}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="plans_with_bids_other">
					<div v-for="(item,index) in row.plans_with_bids_other" style="margin-bottom: 5px;"  :key="index">
						<span style="margin-bottom: 10px;">{{item}}</span>
					</div>
				</template>								
			</Table>
		</div>
		<h3>投放表</h3>
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="defaultColumns" :data="datas" ref="table" :row-class-name="rowClassName">
				<template slot-scope="{ row,index }" slot="standard">
					<div v-for="(item,index) in row.ad_standard_remark" style="text-align: left;" :key="index">
						<span style="margin-bottom: 5px;">{{index+1}}、{{item.alarm_detail}}</span>
					</div>
				</template>
				<template slot-scope="{ row, index }" slot="status">
					<i-switch v-model="datas[index].status" size="large" @on-change="saveOpen($event, index)">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
				<template slot-scope="{ row,index }" slot="plan_time">
					<span>{{row.startTime}}-{{row.endTime}}</span>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="editadPlan">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="delAdplan">删除</Button>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal v-model="addSingleDefaultCostModal" title="添加默认需求">
			<Form :model="formItem" :label-width="100">
				<FormItem label="投放计划名称">
					<Input v-model="formItem.ad_plan_name" style="width: 200px;margin-left: 10px;">
					</Input>
				</FormItem>
				<FormItem label="投放产品">
					<Select v-model="formItem.adv_type" style="width: 200px;margin-left: 10px;">
						<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">
							{{ item.type}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="城市">
					<Select v-model="formItem.city" multiple style="width: 200px;margin-left: 10px;">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="出价">
					<Input v-model="formItem.bid" style="width: 200px;margin-left: 10px;">
					<span slot="append">元</span>
					</Input>
				</FormItem>
				<FormItem label="投放时间段">
					<TimePicker type="timerange" :steps="[1, 15, 15]" v-model="formItem.plan_time" format="HH:mm"
						placement="bottom-end" placeholder="请选择投放时间段"></TimePicker>
				</FormItem>
				<FormItem label="投放异常标准">
					<CheckboxGroup v-model="formItem.ad_standard_list">
						<Checkbox v-for="item in adPlanIndexStandardList" :label="item.id">
							<span>{{item.alarm_name}}({{item.alarm_type_name}}类)</span>
						</Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="投放状态">
					<i-switch v-model="formItem.status" size="large">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
				<FormItem label="备注">
					<Input v-model="formItem.remark" style="width: 200px;margin-left: 10px;">
					</Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="saveSingleAdplan">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="indexStandardModal" width="1000px" title="投放指标管理">
			<addAdvPlanIndexStandard></addAdvPlanIndexStandard>
		</Modal>
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		getAdplanList,
		saveSingleAdplan,
		getAdplan,
		delAdplan,
		getCidTypeList,
		saveAdStatusOpen,
		saveAllDemand,
		saveDemandCover,
		editDemandToZero,
		getadPlanIndexStandardList,
		stopCityDemand
	} from "../../api/advManage.js";
	import advHistoryData from "./components/advHistoryData.vue"; //
	import addAdvPlanIndexStandard from "./components/addAdvPlanIndexStandard.vue"; //

	import cityData from "../../assets/citydata";

	export default {
		name: "adv_plan_manage",
		components: {
			advHistoryData,

			addAdvPlanIndexStandard
		},

		data() {
			return {
				datas: [],
				allDatas: [],
				page: 1,
				pageSize: 20,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				city: '',
				advCity: '',
				cid_type: [],
				selectDay: [],
				copyTime: [],
				name: '',
				copySourceTime: [],
				adPlanIndexStandardList: {},
				tabNum: 1,
				addSingleDefaultCostModal: false,
				formItem: {},
				indeterminate: true,
				checkAll: false,
				indeterminateCidType: true,
				checkAllCidType: false,
				indexStandardModal: false,
				checkThreePlusStatus: false,
				dayList: [{
						value: 1,
						label: '星期一'
					},
					{
						value: 2,
						label: '星期二'
					},
					{
						value: 3,
						label: '星期三'
					},
					{
						value: 4,
						label: '星期四'
					},
					{
						value: 5,
						label: '星期五'
					},
					{
						value: 6,
						label: '星期六'
					},
					{
						value: 7,
						label: '星期天'
					},
				],
				cityList: [],
				cidTypeList: [],
				allColumns: [{
						"title": "类型",
						"key": "type",
						"align": 'center',
						"width": '200px'
					}, {
						"title": "城市",
						"key": "cities",
						"align": 'center',
					},
					{
						"title": "计划A",
						"slot": "plans_with_bids_combination",
						"align": 'center',

					},
					{
						"title": "计划B",
						"slot": "plans_with_bids_single",
						"align": 'center',

					},
					{
						"title": "计划C",
						"slot": "plans_with_bids_other",
						"align": 'center',

					}
				],
				defaultColumns: [{
						"title": "类型",
						"key": "type",
						"align": 'center',
					},
					{
						"title": "投放计划名称",
						"key": "ad_plan_name",
						"align": 'center',
						"width": '150px'
					}, {
						"title": "城市",
						"key": "city",
						"align": 'center',
						"width": '200px'
					},

					{
						"title": "出价",
						"key": "bid",
						"align": 'center',
					},
					{
						"title": "投放时间段",
						"slot": "plan_time",
						"align": 'center',
					},
					{
						"title": "投放状态",
						"slot": "status",
						"align": 'center',
					},

					{
						"title": "备注",
						"key": "remark",
						"align": 'center',
						"width": '200px'
					},
					{
						"title": "操作",
						"slot": "action",
						"align": 'center',
						"width": '200px'
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();

		},
		methods: {

			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				res = await getadPlanIndexStandardList(that, data);
				that.adPlanIndexStandardList = res.data.list;
				this.getList();
			},
			mySearch(e) {
				this.page = 1;
				this.getList();
			},
			checkThreePlus() {
				if (this.checkThreePlusStatus == false) {
					this.checkThreePlusStatus = true;
				} else if (this.checkThreePlusStatus == true) {
					this.checkThreePlusStatus = false;
				}

			},
			editData() {
				this.editStatus = 1;
			},
			tabClick(e) {
				if (e == "name1") {
					this.tabNum = 1;
				} else if (e == "name2") {
					this.tabNum = 2;
				} else if (e == "name3") {
					this.tabNum = 3;
				}
			},
			async stopCityDemand(adv_type, stop_status, row) {
				let that = this;
				if (that.editStatus == 1) {
					return;
				}
				if (that.userInfo.role_type != 1) {
					return;
				}
				console.log(stop_status)
				if (adv_type == 1) {
					var city = row.city + '公积金'
				} else if (adv_type == 2) {
					var city = row.city + '房抵'
				} else if (adv_type == 3) {
					var city = row.city + '车抵'
				} else if (adv_type == 4) {
					var city = row.city + '企业'
				} else if (adv_type == 5) {
					var city = row.city + '综合'
				} else if (adv_type == 6) {
					var city = row.city + '朋友圈'
				} else if (adv_type == 7) {
					var city = row.city + '社保'
				}
				if (stop_status == 0 || stop_status == undefined) {
					row.stop_status = 1;
					var title = '确认要暂停' + city + '产品吗？'
				} else if (stop_status == 1) {
					row.stop_status = 0;
					var title = '确认要启动' + city + '产品吗？'
				}
				row.adv_type = adv_type
				that.$Modal.confirm({
					title: title,
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								data: row
							};
							console.log(row)
							let res = await stopCityDemand(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 1000);
					}
				})
			},
			rowClassName(row, index) {
				if (row.status == 1) {
					return "start-status";
				} else {
					return "stop-status";
				}
			},
			initSearch() {
				this.name = '';
				this.cid_type = [];
				this.getList();
			},
			addSingleDefaultCityDemand() {
				this.formItem = {}
				this.addSingleDefaultCostModal = true;
			},
			addIndexStandard() {
				this.indexStandardModal = true;
			},
			saveOpen(e, index) {
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAdStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
						that.getList();
					}
				}, 200)
			},
			async getList() {
				let that = this;
				let data = this.$data;
				data.token = that.token;
				let res = await getAdplanList(that, data);
				that.datas = res.data.list;
				that.allDatas = res.data.allAdvTypeStartList;
				that.count = res.count;
			},
			async saveAllDemand() {
				let that = this;
				let data = {
					token: that.token,
					data: that.datas
				};
				let res = await saveAllDemand(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.getList();
					this.editStatus = 0;
				}
			},
			async saveSingleAdplan() {
				let that = this;

				let data = {
					token: that.token,
					data: that.formItem
				};
				let res = await saveSingleAdplan(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.addSingleDefaultCostModal = false;
					that.getList();
				}
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.dayList) {
						this.formItem.day_type.push(this.dayList[i].value);
					}
				} else {
					this.formItem.day_type = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 7) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			handleCheckAllCidType() {
				if (this.indeterminateCidType) {
					this.checkAllCidType = false;
				} else {
					this.checkAllCidType = !this.checkAllCidType;
				}
				this.indeterminateCidType = false;

				if (this.checkAllCidType) {
					for (let i in this.cidTypeList) {
						this.formItem.adv_type.push(this.cidTypeList[i].id);
					}
				} else {
					this.formItem.adv_type = [];
				}
			},
			// 编辑投放计划
			async editadPlan(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getAdplan(that, data);
				console.log(res)
				if (res.code == 1) {
					that.formItem = res.data.item;
					that.addSingleDefaultCostModal = true;
				}
			},
			// 删除账户
			delAdplan(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delAdplan(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			checkAllGroupChangeCidType(data) {
				let len = this.cidTypeList.length
				if (data.length === len) {
					this.indeterminateCidType = false;
					this.checkAllCidType = true;
				} else if (data.length > 0) {
					this.indeterminateCidType = true;
					this.checkAllCidType = false;
				} else {
					this.indeterminateCidType = false;
					this.checkAllCidType = false;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			delDefaultCost(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认要删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								id: id
							}
							data.token = this.token;
							let res = await delDefaultCost(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								this.getDefaultAdvCost();
							}
						}, 500)
					}
				})
			},
			saveDefaultCost(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: {
							id: that.defaultData[index].id,
							city: that.defaultData[index].city,
							cid: that.defaultData[index].cid,
							defult_form_cost: that.defaultData[index].defult_form_cost,
						}
					};
					let res = await saveSingleDefaultCost(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.getDefaultAdvCost();
					}
				}, 500)

			},

		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #0055ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: #ffff00;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.first {
		background-color: #d47e83;

		color: #fff;

	}

	.check-threeplus-false {
		color: cornflowerblue;
	}

	.check-threeplus-true {
		color: #fff;
	}

	.second {

		background-color: #277dd3;
		cursor: pointer;
		color: #fff;

	}

	/deep/ .start-status {
		background-color: #005500;
		border-bottom: 1px solid;
		/* 或其他颜色和宽度 */
		cursor: pointer;
	}

	/deep/ .stop-status {
		background-color: #55ff00;
		text-decoration: line-through double red;
		cursor: pointer;
	}
</style>